import React, { useState } from 'react';

function MergeConfirmModal({ conflictEmail, onConfirm, onCancel }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleConfirm = async () => {
    setLoading(true);
    setError(null);
    try {
      await onConfirm();
    } catch (err) {
      setError(err.message || 'Failed to merge accounts');
      setLoading(false);
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={{ fontSize: '48px', marginBottom: '12px' }}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>

        <h2 style={styles.title}>Merge Accounts?</h2>
        <p style={styles.description}>
          An account already exists with <strong>{conflictEmail}</strong>.
        </p>
        <p style={styles.description}>
          Merging will move all expenses, receipts, and data from that account into your current account. This action cannot be undone.
        </p>

        {error && <div style={styles.error}>{error}</div>}

        <div style={styles.actions}>
          <button
            onClick={handleConfirm}
            disabled={loading}
            style={{
              ...styles.mergeButton,
              opacity: loading ? 0.5 : 1,
              cursor: loading ? 'not-allowed' : 'pointer',
            }}
          >
            {loading ? 'Merging...' : 'Merge Accounts'}
          </button>
          <button
            onClick={onCancel}
            disabled={loading}
            style={styles.cancelButton}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
    padding: '20px',
  },
  modal: {
    backgroundColor: 'white',
    borderRadius: '20px',
    padding: '36px',
    maxWidth: '440px',
    width: '100%',
    boxShadow: '0 16px 32px rgba(0, 0, 0, 0.08)',
    textAlign: 'center',
  },
  title: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#111827',
    margin: '0 0 12px',
    letterSpacing: '-0.025em',
  },
  description: {
    fontSize: '14px',
    color: '#71717A',
    lineHeight: '1.6',
    margin: '0 0 8px',
    letterSpacing: '-0.011em',
  },
  error: {
    padding: '10px 14px',
    borderRadius: '10px',
    backgroundColor: '#FEE2E2',
    color: '#991B1B',
    fontSize: '13px',
    marginTop: '12px',
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginTop: '24px',
  },
  mergeButton: {
    padding: '12px',
    fontSize: '15px',
    fontWeight: '500',
    backgroundColor: '#f59e0b',
    color: 'white',
    border: 'none',
    borderRadius: '14px',
    transition: 'all 0.2s ease',
  },
  cancelButton: {
    padding: '10px',
    fontSize: '14px',
    color: '#71717A',
    backgroundColor: 'transparent',
    border: '1px solid #E0E0E0',
    borderRadius: '14px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
};

export default MergeConfirmModal;
